// extracted by mini-css-extract-plugin
export default {"room-header":"RoomHeader_room-header__nLxr9","remove-link":"RoomHeader_remove-link__UfBGx","title":"RoomHeader_title__YUg-A"};